/** 平成30年法改正基準日*/
export const H30_CHANGE_LAW_BASE_DATE = "2018-04-01";

/** 令和2年法改正基準日*/
export const R2_CHANGE_LAW_BASE_DATE = "2020-04-01";

/** 令和3年法改正基準日*/
export const R3_CHANGE_LAW_BASE_DATE = "2021-04-01";

/** 令和8年法改正基準年月 */
export const R8_CHANGE_LAW_BASE_YM = "2026-06";
